import React from "react"
import * as models from "../models/index"
import { DonutMathResponse } from "../models/donuts"
import DonutChart from "./DonutChart"
import MultiplicationIcon from "./DonutIcons/Multiplication"
import { RequestError } from "models/lib/modelRequest"
import { toast } from "react-toastify"

export default class MultiplicationDonut extends React.Component<{
  studentID?: string
  onLoaded?: (donutsResponse: DonutMathResponse) => void
  refresh?: boolean
}, {
  donutData: DonutMathResponse
  loading: boolean
}> {
  state = {
    loading: true,
    donutData: null
  }

  componentDidMount() {
    this.loadDonuts()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.refresh && this.props.refresh) {
      this.loadDonuts()
    }
  }

  loadDonuts = () => {
    models.donuts.getMathProgress({
      studentID: this.props.studentID
    }).then((donutData) => {
      this.setState({ donutData }, () => {
        if (typeof this.props.onLoaded === 'function') {
          this.props.onLoaded(donutData)
        }
      })
    }).catch((error: RequestError) => {
      toast.error(error)
    }).finally(() => {
      this.setState({ loading: false })
    })

  }

  render() {

    if (this.state.loading) {
      return <></>
    }

    var { multiplication } = this.state?.donutData
    return (
      <div className="text-center">
        <DonutChart
          label="Multiplication"
          total={multiplication.total}
          completed={multiplication.completed}
          baseColor={"#DF554B"}
          Icon={MultiplicationIcon}
        />
      </div>
    )
  }
}
